import React from 'react';
import {Link} from 'react-router-dom';
import withLifecycles from 'async-lifecycles';
import {Button, Form, Header, Message} from 'semantic-ui-react';
import produce from 'immer';

import {FormWrapper, Wrapper} from './Layout';
import {FormattedMessage} from '../i18n/Context';
import api from '../../store/services/api';
import {ErrorMessages} from '../form-components/ErrorMessages';

class CompleteRegistration extends React.Component {
  state = {
    loading: false,
    error: {},
    emailAddress: '',
  };
  _mutateState = mutationFn => {
    this.setState(produce(mutationFn));
  };
  _handleInputChanged = (event, {name, value}) => {
    this._mutateState(state => {
      state[name] = value;
    });
  };
  _resetPassword = () => {
    withLifecycles(
      () => {
        return api.patch(
          `/accounts/forgot-password/initiate/${this.state.emailAddress}`,
        );
      },
      ({loading, data, error}) => {
        this.setState({loading, data, error});
      },
    );
  };

  render() {
    const {loading, emailAddress, data, error} = this.state;
    return (
      <Wrapper>
        <Header textAlign="center">
          <img
            src={`${process.env.PUBLIC_URL}/mm_logo.png`}
            alt="M&M International"
          />
        </Header>
        <FormWrapper attached loading={loading}>
          <Header textAlign="center">
            <FormattedMessage id="forgotPassword.form.header" />
          </Header>
          {data &&
            !data.hasErrors && (
            <Message info>
              <FormattedMessage id="forgotPassword.form.checkEmail" />
            </Message>
          )}
          {(!data || data.hasErrors) && (
            <Form onSubmit={this._resetPassword}>
              <Form.Field>
                <FormattedMessage id="forgotPassword.form.emailAddress" />
                <Form.Input
                  type="email"
                  name="emailAddress"
                  value={emailAddress}
                  onChange={this._handleInputChanged}
                  autoFocus
                />
              </Form.Field>
              <ErrorMessages error={error} />
              <div className="stacked-buttons">
                <Button type="submit" primary fluid disabled={!emailAddress}>
                  <FormattedMessage id="forgotPassword.form.button.submit" />
                </Button>
                <Button as={Link} to="/account/login" className="clear" fluid>
                  <FormattedMessage id="forgotPassword.form.link.returnToLogin" />
                </Button>
              </div>
            </Form>
          )}
        </FormWrapper>
      </Wrapper>
    );
  }
}

export default CompleteRegistration;
